import * as React from "react";
import QueryString from "query-string"
import { Redirect } from "react-router";

class Ingress extends React.Component<any> {
    constructor(props: any) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
        window.history.pushState({}, "Ingress", "/");
        //console.log("/Ingress")
        //const { wfId, docNo, wfInstanceNo, userId } = this.props.match.params
        const { token, redirect } = QueryString.parse(this.props.location.search);

        var jwt = this.parseJwt(token)
        var extra = JSON.parse(jwt.extra)
        var data = {
            access_token: token,
            /*            user_id: extra.user_id*/
        }

        localStorage.removeItem('LG_APPLICATION');
        localStorage.setItem('LG_APPLICATION', JSON.stringify(data));

        if (!redirect || !window.top) return;

        console.log(redirect)
        window.top.location.href = atob(redirect as string);
    }

    parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    };

    componentDidUpdate() {
    }

    render() {
        return <Redirect to='/' />
    }
}

export default Ingress
